module.exports = __webpack_public_path__ + "static/img/personal-bg.8c1699d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mobile/personal-bg.png
// module id = 977
// module chunks = 41